import { combineEpicsAndCatchErrors } from "../../../generic/redux/CombineEpicsAndCatchErrors";

import { SessionEpic } from "./CheckSessionEpic";

export const GlobalEpic = combineEpicsAndCatchErrors(SessionEpic);
